import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { DocumentService } from '../../../../../../services/document/document.service';
import { Router } from '@angular/router';
import { SignerService } from '../../../../../../services/signer/signer.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-templateContract1',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './templateContract1.component.html',
  styleUrls: ['./templateContract1.component.css'],
})
export class TemplateContract1 implements OnInit {
  
  selectedSigners: string[] = [];
  availableSigners: any[] = [];

  currentStep = 1;

  contractorType: string = '';

  naturalData = {
    name: '',
    idType: 'CC',
    id: '',
    place: '',
    address: '',
    city: '',
    department: '',
    email: '',
    phone: ''
  };

  juridicaData = {
    juridicaName: '',
    juridicaIdType: 'CC',
    nit: '',
    address: '',
    city: '',
    department: '',
    email: '',
    representative: '',
    representativeId: '',
  };

  contractDetails = {
    contractType: '', 
    contractDate: '', 
    contractNumber: '', 
    objectDescription: '', 
    contractDuration: '', 
    totalValue: '', 
    installments: '',
    workType: '', 
    fundingSource: '', 
    cdpNumber: '', 
    cdpDate: '', 
    contractorObligations: '', 
    contractorDuties: '', 
  };

  guarantees = {
    guaranteeType: '',
    insurer: '',
    guaranteeAmount: '',
    penaltyAmount: '',
    penaltyBase: '',
    fineAmount: '',
    fineBase: '',
  };

  constructor( private router: Router, private route: ActivatedRoute,private http: HttpClient, private documentService: DocumentService,private signerService: SignerService)  {}

  
  ngOnInit(): void {
    const formId = this.route.snapshot.queryParamMap.get('formId');
    const menuId = this.route.snapshot.queryParamMap.get('menuId');
    this.loadSigners();
    if (!formId || !menuId) {
      return;
    }
  
    this.documentService.getFormData(formId, menuId).subscribe({
      next: (response) => {
        const formData = response.formData;
        this.populateFormData(formData);
      },
      error: (err) => {
        console.error('Error al recuperar formulario:', err);
        alert('No se pudo cargar el formulario.');
      }
    });
  }
  
  populateFormData(formData: any) {
    this.contractDetails = {
      contractType: formData.contractType || '',
      contractDate: formData.contractDate || '',
      contractNumber: formData.contractNumber || '',
      objectDescription: formData.objectDescription || '',
      contractDuration: formData.contractDuration || '',
      totalValue: formData.totalValue || '',
      installments: formData.installments || '',
      workType: formData.workType || '',
      fundingSource: formData.fundingSource || '',
      cdpNumber: formData.cdpNumber || '',
      cdpDate: formData.cdpDate || '',
      contractorObligations: formData.contractorObligations || '',
      contractorDuties: formData.contractorDuties || ''
    };
  
    this.naturalData = {
      name: formData.name || '',
      idType: formData.idType || '',
      id: formData.id || '',
      place: formData.place || '',
      address: formData.address || '',
      city: formData.city || '',
      department: formData.department || '',
      email: formData.email || '',
      phone: formData.phone || ''
    };
  
    this.juridicaData = {
      juridicaName: formData.juridicaName || '',
      juridicaIdType: formData.juridicaIdType || '',
      nit: formData.nit || '',
      address: formData.juridicaAddress || '',
      city: formData.juridicaCity || '',
      department: formData.juridicaDepartment || '',
      email: formData.juridicaEmail || '',
      representative:  formData.representative || '',
      representativeId:  formData.representativeId || ''
    };
  
    this.guarantees = {
      guaranteeType: formData.guaranteeType || '',
      insurer: formData.insurer || '',
      guaranteeAmount: formData.guaranteeAmount || '',
      penaltyAmount: formData.penaltyAmount || '',
      penaltyBase: formData.penaltyBase || '',
      fineAmount: formData.fineAmount || '',
      fineBase: formData.fineBase || ''
    };
  
    this.selectedSigners = formData.selectedSigners || [];
  }
  
    generateDocument() {
      const formData = {
        ...this.contractDetails,
        ...this.naturalData,
        ...this.juridicaData,
        ...this.guarantees,
        selectedSigners: this.selectedSigners
      };
    
      const menuId = '1';
    
      this.documentService.generateDocument(formData, menuId).subscribe({
        next: (res) => {
          console.log('Documento generado:', res);   
          if (res?.url) {
            const link = document.createElement('a');
            link.href = res.url;
            link.download = '';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            alert('Documento generado pero no se recibió una URL de descarga.');
          }
        },
        error: (err) => {
          console.error('Error al generar el documento:', err);
          alert('No se pudo generar el documento.');
        }
      });
    }
    

  goToNextStep(): void {
    if (this.contractorType === 'natural') {
      localStorage.setItem(
        'formData',
        JSON.stringify({
          contractorType: this.contractorType,
          naturalData: this.naturalData,
          contractDetails: this.contractDetails,
          guarantees: this.guarantees,
        })
      );
    }
    else{
      localStorage.setItem(
        'formData',
        JSON.stringify({
          contractorType: this.contractorType,
          juridicaData: this.juridicaData,
          contractDetails: this.contractDetails,
          guarantees: this.guarantees,
        })
      );
    }
    if (this.currentStep < 3) {
      this.currentStep++;
      this.scrollToTop();
    }
  }

  goToPreviousStep(): void {
    const savedFormData = localStorage.getItem('formData');
    if (savedFormData) {
      const formData = JSON.parse(savedFormData);

      this.contractorType = formData.contractorType || this.contractorType;
      this.naturalData = formData.naturalData || this.naturalData;
      this.juridicaData = formData.juridicaData || this.juridicaData;
      this.contractDetails = formData.contractDetails || this.contractDetails;
      this.guarantees = formData.guarantees || this.guarantees;
    }

    if (this.currentStep > 1) {
      this.currentStep--;
      this.scrollToTop();
    }
  }

  saveAsDraft() {
    const formData = {
      ...this.contractDetails,
      ...this.naturalData,
      ...this.juridicaData,
      ...this.guarantees,
      selectedSigners: this.selectedSigners
    };
  
    const menuId = '1';
  
    this.documentService.saveForm(formData, menuId).subscribe({
      next: (res) => {
        console.log('Formulario guardado como borrador:', res);
        alert('Formulario guardado correctamente.');
      },
      error: (err) => {
        console.error('Error al guardar el formulario:', err);
        alert('Ocurrió un error al guardar el formulario.');
      }
    });
  }

  clearLocalStorage(): void {
    localStorage.clear();
  }

  loadSigners() {
    this.signerService.getSigners().subscribe({
      next: (res) => {
        this.availableSigners = res.signers || [];
        console.log('Firmantes cargados:', this.availableSigners);
      },
      error: (err) => {
        console.error('Error al obtener firmantes:', err);
        alert('No se pudieron cargar los firmantes.');
      }
    });
  }
  
  

  toggleSignerSelection(signerId: string) {
    if (this.selectedSigners.includes(signerId)) {
      this.selectedSigners = this.selectedSigners.filter(id => id !== signerId);
    } else {
      this.selectedSigners.push(signerId);
    }
  }

  private scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
 
}


